import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonComponentsModule} from '../../../common-components.module';
import {EmailService} from '../../../services/email.service';
import {ComposeEmailComponent} from './compose-email.component';
import {ChoiceRecipientsComponent} from '../choice-recipients-modal/choice-recipients-modal.component';
import {AngularMaterialImportModule} from '../../../components/angular-material-import-module/angular-material-import.module';
import {FilterByPropertyPipeModule} from '../../../pipes/filter-by-property-pipe/filter-by-property-pipe.module';
import {EmailSchedulingModalComponent} from '../email-scheduling-modal/email-scheduling-modal.component';
import {ChooseCorporationModalComponent} from '../choose-corporation-modal/choose-corporation-modal.component';
import {AngularMultiSelectModule} from '../../../components/angular2-multiselect-dropdown/multiselect.component';
import {RecipientsFilterComponent} from '../recipients-filter/recipients-filter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        FilterByPropertyPipeModule,
        AngularMultiSelectModule,
        NgSelectModule,
        UtilsModule
    ],
    declarations: [
        ComposeEmailComponent,
        ChoiceRecipientsComponent,
        EmailSchedulingModalComponent,
        ChooseCorporationModalComponent,
        RecipientsFilterComponent
    ],
    providers: [
        EmailService
    ]
})
export class ComposeEmailModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/email/compose-email/compose-email.module.ts